module.exports = __webpack_public_path__ + "img/it-about.bdb25bcc.jpg";